"use client";

import { c as _c } from "react/compiler-runtime";
function SkeletonBlock(t0) {
  const $ = _c(2);
  const {
    className
  } = t0;
  const t1 = `tw-animate-pulse tw-rounded ${className}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
function MemesQuickVoteDropHeaderSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBlock className="tw-size-11 tw-rounded-full tw-bg-iron-800/80" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-items-center tw-gap-3">{t0}<div className="tw-min-w-0 tw-flex-1 tw-space-y-2"><div className="tw-flex tw-items-center tw-gap-2"><SkeletonBlock className="tw-h-4 tw-w-28 tw-bg-iron-800/80" /><SkeletonBlock className="tw-size-1 tw-rounded-full tw-bg-iron-700" /><SkeletonBlock className="tw-h-3 tw-w-12 tw-bg-iron-800/60" /></div><SkeletonBlock className="tw-h-3 tw-w-20 tw-bg-iron-800/60" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function MemesQuickVoteCopySkeleton(t0) {
  const $ = _c(9);
  const {
    descriptionLineClassNames,
    titleClassName
  } = t0;
  let t1;
  if ($[0] !== titleClassName) {
    t1 = <SkeletonBlock className={titleClassName} />;
    $[0] = titleClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== descriptionLineClassNames) {
    t2 = descriptionLineClassNames.map(_temp);
    $[2] = descriptionLineClassNames;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="tw-space-y-2">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div>{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(className) {
  return <SkeletonBlock key={className} className={className} />;
}
function MemesQuickVoteActionBarSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBlock className="tw-h-3 tw-w-20 tw-bg-iron-800/60" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-1.5 tw-px-0.5 sm:tw-gap-2 sm:tw-px-1 md:tw-flex-nowrap">{t0}<div className="tw-flex tw-items-center tw-gap-1.5 tw-rounded-xl tw-bg-iron-900/70 tw-px-3 tw-py-1 sm:tw-gap-2 sm:tw-py-1.5"><SkeletonBlock className="tw-size-3.5 tw-rounded-full tw-bg-iron-700/50" /><SkeletonBlock className="tw-h-4 tw-w-32 tw-bg-iron-700/40" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-relative tw-bg-[linear-gradient(180deg,rgba(10,10,12,0.68),rgba(10,10,12,0.94))] tw-px-3 tw-pb-[calc(env(safe-area-inset-bottom,0px)+0.375rem)] tw-pt-1.5 tw-backdrop-blur-[28px] sm:tw-pb-[calc(env(safe-area-inset-bottom,0px)+0.5rem)] sm:tw-pt-2 md:tw-relative md:tw-z-20 md:tw-shrink-0 md:tw-p-0 md:tw-px-8 md:tw-pb-6 md:tw-pt-0"><div className="tw-relative tw-z-10 tw-flex tw-flex-col tw-gap-2 sm:tw-gap-3"><div className="tw-flex tw-flex-col tw-gap-2 tw-rounded-xl tw-bg-iron-950/95 tw-p-3 tw-shadow-[0_12px_28px_rgba(0,0,0,0.22)] sm:tw-gap-3 sm:tw-p-4 md:tw-p-5 md:tw-shadow-[0_20px_40px_rgba(0,0,0,0.18)]">{t1}<div className="tw-flex tw-h-11 tw-items-stretch tw-gap-1.5 sm:tw-h-12 sm:tw-gap-2 md:tw-h-12"><SkeletonBlock className="tw-h-full tw-min-w-0 tw-flex-1 tw-rounded-xl tw-bg-iron-900 md:tw-rounded-lg" /><SkeletonBlock className="tw-h-full tw-w-24 tw-rounded-xl tw-bg-iron-800/80 md:tw-w-20 lg:tw-w-24" /></div></div><SkeletonBlock className="tw-h-11 tw-w-full tw-rounded-xl tw-bg-iron-950 sm:tw-h-12" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default function MemesQuickVoteDialogSkeleton() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="tw-sr-only">Loading your queue. Pulling unrated memes and your recent quick-vote amounts.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div data-testid="quick-vote-preview-status" className="tw-hidden"><SkeletonBlock className="tw-h-8 tw-w-32 tw-rounded-full tw-bg-iron-800/60" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-white/5 tw-bg-black/40 tw-px-4 tw-pb-3 tw-pt-[calc(env(safe-area-inset-top,0px)+0.75rem)] tw-backdrop-blur-xl md:tw-hidden"><SkeletonBlock className="tw-size-10 tw-rounded-full tw-bg-iron-800/80" /><SkeletonBlock className="tw-h-4 tw-w-28 tw-rounded-full tw-bg-iron-800/55" /><div className="tw-size-10 tw-shrink-0" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-relative tw-flex tw-h-[45vh] tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-border-b tw-border-solid tw-border-white/5 tw-bg-black/40 md:tw-flex md:tw-h-full md:tw-w-full md:tw-items-center md:tw-justify-center md:tw-border-0"><SkeletonBlock className="tw-h-full tw-w-full tw-bg-iron-800/60" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MemesQuickVoteDropHeaderSkeleton />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-min-h-0 tw-flex-1 md:tw-min-h-0 md:tw-border-y-0 md:tw-border-b-0 md:tw-border-l-0 md:tw-border-r md:tw-border-solid md:tw-border-white/10"><article className="tw-relative tw-flex tw-h-full tw-flex-col tw-overflow-hidden"><div data-testid="quick-vote-preview-mobile-context" className="tw-flex tw-h-full tw-flex-col md:tw-flex md:tw-min-h-0 md:tw-flex-1 md:tw-p-0">{t3}<div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-bg-[#0d0d0e] md:tw-hidden"><div className="tw-min-h-0 tw-flex-1 tw-overflow-hidden tw-px-6 tw-pb-5 tw-pt-4"><div className="tw-flex tw-flex-col tw-gap-4">{t4}<MemesQuickVoteCopySkeleton titleClassName="tw-h-7 tw-w-3/4 tw-bg-iron-800/80" descriptionLineClassNames={["tw-h-4 tw-w-11/12 tw-bg-iron-800/60"]} /></div></div></div></div></article></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-shrink-0 tw-border-t tw-border-solid tw-border-white/5 tw-bg-[#0a0a0a] md:tw-hidden"><MemesQuickVoteActionBarSkeleton /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-hidden tw-shrink-0 tw-flex-wrap tw-gap-2 tw-px-8 md:tw-flex md:tw-pb-6 md:tw-pt-6"><SkeletonBlock className="tw-h-8 tw-w-32 tw-rounded-full tw-bg-iron-800/60" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MemesQuickVoteDropHeaderSkeleton />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div role="status" aria-live="polite" aria-busy="true" data-testid="quick-vote-loading-skeleton" className="tw-flex tw-h-full tw-flex-col md:tw-grid md:tw-min-h-0 md:tw-grid-cols-[minmax(0,1.22fr)_minmax(25rem,1fr)] md:tw-items-stretch">{t0}{t1}{t2}<div className="tw-relative tw-min-h-0 tw-flex-1 md:tw-contents">{t5}{t6}<div data-testid="quick-vote-controls-desktop-context" className="tw-hidden tw-shrink-0 tw-flex-col tw-gap-0 md:tw-flex md:tw-h-full md:tw-min-h-0 md:tw-overflow-hidden md:tw-bg-[#0a0a0a]/30">{t7}<div className="tw-relative tw-hidden tw-min-h-0 tw-flex-1 md:tw-flex"><div className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-pb-16 [-ms-overflow-style:none] [scrollbar-width:none] md:tw-px-8 [&::-webkit-scrollbar]:tw-hidden"><div className="tw-flex tw-w-full tw-flex-col tw-gap-5">{t8}<MemesQuickVoteCopySkeleton titleClassName="tw-mb-3 tw-mt-4 tw-h-8 tw-w-4/5 tw-bg-iron-800/80 md:tw-h-9" descriptionLineClassNames={["tw-h-4 tw-w-full tw-bg-iron-800/60", "tw-h-4 tw-w-11/12 tw-bg-iron-800/60", "tw-h-4 tw-w-5/6 tw-bg-iron-800/60", "tw-h-4 tw-w-3/5 tw-bg-iron-800/60"]} /></div></div><div className="tw-pointer-events-none tw-absolute tw-inset-x-8 tw-bottom-0 tw-h-16 tw-bg-gradient-to-t tw-from-[#0a0a0a] tw-via-[#0a0a0a]/85 tw-to-transparent" /></div><MemesQuickVoteActionBarSkeleton /></div></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}